const updates = [
  {
    date: '07-29',
    title: '《孤胆狙击》高清资源上线',
    desc: '年度动作大片高清完整版现已加入91电影免费片库。',
    tag: '新片上线',
  },
  {
    date: '07-28',
    title: '暑期档专题策划发布',
    desc: '精选50部暑期必看国产电影，一站式观影指南。',
    tag: '专题',
  },
  {
    date: '07-27',
    title: '播放器性能全面升级',
    desc: '优化视频加载速度，4K片源播放更加流畅稳定。',
    tag: '系统',
  },
  {
    date: '07-26',
    title: '悬疑电影周特别企划',
    desc: '每日一部高分悬疑片推荐，烧脑不停歇。',
    tag: '活动',
  },
  {
    date: '07-25',
    title: '《长安十二夜》独家上线',
    desc: '年度最受期待悬疑剧集，91电影全网免费首播。',
    tag: '新片上线',
  },
  {
    date: '07-24',
    title: '移动端体验优化完成',
    desc: '手机观影界面全新改版，操作更便捷更直观。',
    tag: '系统',
  },
  {
    date: '07-23',
    title: '科幻电影专区扩容',
    desc: '新增200+部国内外科幻影片，满足科幻迷所有需求。',
    tag: '更新',
  },
  {
    date: '07-22',
    title: '《山海传说》4K修复版发布',
    desc: '经典奇幻巨制高清修复，重温东方神话魅力。',
    tag: '新片上线',
  },
];

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-3">
            最新动态
          </h2>
          <p className="text-foreground-500 text-sm">片库更新、平台公告，一手掌握</p>
        </div>

        <div className="max-w-3xl mx-auto">
          {updates.map((item, idx) => (
            <div
              key={idx}
              className={`flex items-start gap-4 py-4 ${
                idx < updates.length - 1 ? 'border-b border-background-200/50' : ''
              }`}
            >
              <span className="text-sm text-foreground-500 whitespace-nowrap pt-0.5">{item.date}</span>
              <span className={`px-2 py-0.5 rounded text-xs whitespace-nowrap flex-shrink-0 ${
                item.tag === '新片上线' ? 'bg-accent-500/10 text-accent-300' :
                item.tag === '系统' ? 'bg-secondary-500/10 text-secondary-400' :
                item.tag === '活动' ? 'bg-primary-500/10 text-primary-400' :
                'bg-background-200 text-foreground-500'
              }`}>
                {item.tag}
              </span>
              <div className="min-w-0">
                <h3 className="text-sm font-medium text-foreground-950 truncate">{item.title}</h3>
                <p className="text-xs text-foreground-600 mt-1">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}